import { useMemo, useCallback } from 'react';
import type { IActivity } from './types';

const getLogger = ({ trace, error }: IActivity) => ({
  logTrace: trace,
  logError: error,
});

export const useLogger = (activity: IActivity, featureName: string, subFeatureName?: string) => {
  const logger = useMemo(() => getLogger(activity), [activity]);
  const logPrefix = useMemo(() => `${activity.name}: ${featureName}${subFeatureName ? ` - ${subFeatureName}` : ''}`, [activity, featureName, subFeatureName]);

  const logTrace = useCallback((message: string) => logger.logTrace(`${logPrefix} | ${message}`), [logger, logPrefix]);
  const logError = useCallback((message: string) => logger.logError(`${logPrefix} | ${message}`), [logger, logPrefix]);

  return {
    logTrace,
    logError,
  };
};
